import styled from 'styled-components'

export const FloatingButtonContainer = styled.div``
